import DialogTitle from "@mui/material/DialogTitle";

export default function AppDialogTitle({ children, ...rest }) {
  return <DialogTitle {...rest}>{children}</DialogTitle>;
}
